import {Pipe, PipeTransform} from "@angular/core";
import {PAY_METHOD_OPTIONS} from "../_maps/pay-method-options";

@Pipe({name: "payMethodOption"})
export class PayMethodOptionPipe implements PipeTransform {
  transform(method: string): any {
    return method && PAY_METHOD_OPTIONS[method];
  }
}
